// src/features/auth/Login.js
import React, { useState } from "react";
import { useNavigate,Link } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import "./AuthForm.css";

const Login = ({ showLanding }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const auth = getAuth();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate("/dashboard");
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      {showLanding ? (
        <div className="sf-landing-flex">
          <div className="sf-landing sf-landing-flex-left">
            <div className="sf-landing-inner">
              <h1 className="sf-landing-title">Simplest Feedback</h1>
              <p className="sf-landing-subtitle">The easiest way to collect honest, actionable feedback from anyone.</p>
              <ul className="sf-landing-bullets">
                <li>Share a single link to your personal feedback form</li>
                <li>Get anonymous or attributed feedback instantly</li>
                <li>No setup, no code, no hassle</li>
              </ul>
              <div className="sf-landing-anywhere">Your feedback link works anywhere—share it in your app, website, or email signature.</div>
              <a href="/signup" className="sf-landing-cta">Get Started Free</a>
            </div>
          </div>
          <div className="sf-landing-flex-right">
            <div className={`auth-form-container auth-form-container--compact`}>
              <h2 className="auth-form-title">Log In</h2>
              <form className="auth-form" onSubmit={handleLogin}>
                <div className="auth-form-group">
                  <label htmlFor="login-email">Email</label>
                  <input
                    id="login-email"
                    type="email"
                    placeholder="Email"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    className="auth-form-input"
                    required
                  />
                </div>
                <div className="auth-form-group">
                  <label htmlFor="login-password">Password</label>
                  <input
                    id="login-password"
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    className="auth-form-input"
                    required
                  />
                </div>
                {error && <div className="auth-form-error">{error}</div>}
                <button className="auth-form-submit" type="submit" disabled={submitting}>
                  {submitting ? "Logging In..." : "Log In"}
                </button>
              </form>
              <p className="auth-form-alt-link">
                Don't have an account? <Link to="/signup">Sign Up</Link>
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className={`auth-form-container`}>
          <h2 className="auth-form-title">Log In</h2>
          <form className="auth-form" onSubmit={handleLogin}>
            <div className="auth-form-group">
              <label htmlFor="login-email">Email</label>
              <input
                id="login-email"
                type="email"
                placeholder="Email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="auth-form-input"
                required
              />
            </div>
            <div className="auth-form-group">
              <label htmlFor="login-password">Password</label>
              <input
                id="login-password"
                type="password"
                placeholder="Password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="auth-form-input"
                required
              />
            </div>
            {error && <div className="auth-form-error">{error}</div>}
            <button className="auth-form-submit" type="submit" disabled={submitting}>
              {submitting ? "Logging In..." : "Log In"}
            </button>
          </form>
          <p className="auth-form-alt-link">
            Don't have an account? <Link to="/signup">Sign Up</Link>
          </p>
        </div>
      )}
    </>
  );
};

export default Login;
